// Function presets (comprehensive, one per function type)
export * from './linear.preset';
export * from './quadratic.preset';
export * from './cubic.preset';
export * from './cubic-general.preset';
export * from './absolute.preset';
export * from './sqrt.preset';
export * from './exponential.preset';
export * from './logarithmic.preset';
export * from './sine.preset';
export * from './cosine.preset';
export * from './tangent.preset';
export * from './rational.preset';
export * from './rational-general.preset';

// Canvas selection test presets
export * from './test-canvas-selection.preset';

// Feature test presets
export * from './test-domain-range.preset';
export * from './test-calculus.preset';
export * from './test-integral.preset';
export * from './test-intersection-area.preset';
export * from './test-trajectory.preset';
export * from './test-snapping-translation.preset';
export * from './test-annotations.preset';
export * from './test-vertex-triangle.preset';
export * from './test-conditional.preset';
export * from './test-fixed-grid.preset';
export * from './test-data-table.preset';

// Legacy presets (kept for backwards compatibility)
export * from './quadratic-exploration.preset';
export * from './quadratic-exploration-abc.preset';
export * from './linear-exploration.preset';

import type { GraphpadWidgetConfig } from '../graphpad.model';

import { LINEAR_PRESET } from './linear.preset';
import { QUADRATIC_PRESET } from './quadratic.preset';
import { CUBIC_PRESET } from './cubic.preset';
import { CUBIC_GENERAL_PRESET } from './cubic-general.preset';
import { ABSOLUTE_PRESET } from './absolute.preset';
import { SQRT_PRESET } from './sqrt.preset';
import { EXPONENTIAL_PRESET } from './exponential.preset';
import { LOGARITHMIC_PRESET } from './logarithmic.preset';
import { SINE_PRESET } from './sine.preset';
import { COSINE_PRESET } from './cosine.preset';
import { TANGENT_PRESET } from './tangent.preset';
import { RATIONAL_PRESET } from './rational.preset';
import { RATIONAL_GENERAL_PRESET } from './rational-general.preset';

import { TEST_DOMAIN_RANGE_PRESET } from './test-domain-range.preset';
import { TEST_CALCULUS_PRESET } from './test-calculus.preset';
import { TEST_INTEGRAL_PRESET } from './test-integral.preset';
import { TEST_INTERSECTION_AREA_PRESET } from './test-intersection-area.preset';
import { TEST_TRAJECTORY_PRESET } from './test-trajectory.preset';
import { TEST_SNAPPING_TRANSLATION_PRESET } from './test-snapping-translation.preset';
import { TEST_ANNOTATIONS_PRESET } from './test-annotations.preset';
import { TEST_VERTEX_TRIANGLE_PRESET } from './test-vertex-triangle.preset';
import { TEST_CONDITIONAL_PRESET } from './test-conditional.preset';
import { TEST_FIXED_AXIS_Y_PRESET, TEST_FIXED_AXIS_X_PRESET } from './test-fixed-grid.preset';
import { TEST_DATA_TABLE_PRESET } from './test-data-table.preset';
import { TEST_CANVAS_SELECTION_PRESET } from './test-canvas-selection.preset';

/**
 * All available Graphpad presets.
 */
export const GRAPHPAD_PRESETS: GraphpadWidgetConfig[] = [
  // Function presets (comprehensive)
  LINEAR_PRESET,
  QUADRATIC_PRESET,
  CUBIC_PRESET,
  CUBIC_GENERAL_PRESET,
  ABSOLUTE_PRESET,
  SQRT_PRESET,
  EXPONENTIAL_PRESET,
  LOGARITHMIC_PRESET,
  SINE_PRESET,
  COSINE_PRESET,
  TANGENT_PRESET,
  RATIONAL_PRESET,
  RATIONAL_GENERAL_PRESET,

  // Feature test presets
  TEST_DOMAIN_RANGE_PRESET,
  TEST_CALCULUS_PRESET,
  TEST_INTEGRAL_PRESET,
  TEST_INTERSECTION_AREA_PRESET,
  TEST_TRAJECTORY_PRESET,
  TEST_SNAPPING_TRANSLATION_PRESET,
  TEST_ANNOTATIONS_PRESET,
  TEST_VERTEX_TRIANGLE_PRESET,
  TEST_CONDITIONAL_PRESET,
  TEST_FIXED_AXIS_Y_PRESET,
  TEST_FIXED_AXIS_X_PRESET,
  TEST_DATA_TABLE_PRESET,
  TEST_CANVAS_SELECTION_PRESET,
];

export type GraphpadPresetId = (typeof GRAPHPAD_PRESETS)[number]['id'];
